export default __webpack_public_path__ + "static/media/porfirio.e378843b.jpg";